import React, { VoidFunctionComponent } from "react";
import { MKPSeller } from "@/components/responsive/product/seller/MkpSeller";
import { MkpSeller } from "@/models/scope/productSheet/mkpSeller/MkpSeller";
import { BUTSeller } from "@/components/responsive/product/seller/ButSeller";

interface Props {
    isWebOnly: boolean,
    seller?: string;
    setLayerType: (layerType: string) => void,
    isLayer: boolean,
    sellerType: string,
    sellerMKP: MkpSeller | undefined,
    setShowCloseLayerButton: (status: boolean) => void;
    isWinningOffer?: boolean;
}

export const Seller: VoidFunctionComponent<Props> = ({
    isWebOnly,
    sellerMKP,
    isLayer,
    setLayerType,
    setShowCloseLayerButton,
    sellerType,
    isWinningOffer,
 }) => {
    if (!sellerType) return null;

    const isBUTSeller = sellerType === 'BUT' || sellerType === 'BUT_MKP';
    
    return (
        <div className='seller-block block-layout'>
            {isBUTSeller ? (
                <BUTSeller isWebOnly={isWebOnly} />
            ) : (sellerMKP &&
                <MKPSeller
                    sellerMKP={sellerMKP}
                    setLayerType={setLayerType}
                    isLayer={isLayer}
                    setShowCloseLayerButton={setShowCloseLayerButton}
                    isWinningOffer={isWinningOffer}
                />
            )}
        </div>
    );
}